import React from "react";
import FileUtils from "../../utils/FileUtils";
import styles from "./RejectedFilesMessage.module.css";

/**
 * @param {Array<{ file: File, reason: string }>} files
 */
export const rejectedFilesList = (files) => (
  <div className={styles.list}>
    {files.map(({ file, reason }, idx) => (
      <div key={`${file.name}-${idx}`} className={styles.item}>
        <div className={styles.header}>
          <code className={styles.name}>{file.name}</code>
          {file.size > 0 && (
            <span className={styles.size}>
              {FileUtils.bytesToMb(file.size).toFixed(1)} MB
            </span>
          )}
        </div>
        <span className={styles.reason}>{reason}</span>
      </div>
    ))}
  </div>
);
